import { ContactNotFoundIcon, LockIconNew } from '@synergy/theme';
import { FormattedMessage } from 'react-intl';
import { Stack, Tooltip, useTheme } from '@mui/material';

import { PaloCardPerson, PaloContactName } from '../palo/palo-contact-card';

interface ContactPresenterProps {
    fullName?: string;
    isLocked?: boolean;
    isDeleted?: boolean;
    /**
     * The person behind the name. Given, the name carries its contact card —
     * phone, mobile and e-mail, straight from the list (LST-S13, #2229).
     */
    person?: PaloCardPerson | null;
}

const PresenterIcon = ({ isLocked, isDeleted }: { isLocked?: boolean; isDeleted?: boolean }) => {
    const theme = useTheme();

    if (isLocked) {
        return (
            <Tooltip title={<FormattedMessage id="app.tooltip.locked" />} placement="top">
                <LockIconNew htmlColor={theme.palette.text.primary} sx={{ fontSize: 16 }} />
            </Tooltip>
        );
    }
    if (isDeleted) {
        return (
            <Tooltip title={<FormattedMessage id="app.tooltip.deleted" />} placement="top">
                <ContactNotFoundIcon htmlColor={theme.palette.text.primary} sx={{ fontSize: 16 }} />
            </Tooltip>
        );
    }
    return null;
};

export const ContactPresenter = (props: ContactPresenterProps) => {
    const { fullName, isLocked, isDeleted, person } = props;

    if (!fullName) {
        return null;
    }

    return (
        <Stack
            direction="row"
            gap={1}
            alignItems="center"
            sx={{ opacity: isDeleted || isLocked ? 0.6 : 1, whiteSpace: 'pre' }}
        >
            <PresenterIcon isLocked={isLocked} isDeleted={isDeleted} />
            {person ? <PaloContactName person={person}>{fullName}</PaloContactName> : fullName}
        </Stack>
    );
};
